"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STRUCTURE_NON_DEDUCTIBLE_MODES = exports.STRUCTURE_MODES = exports.STRUCTURE_LEVELS = exports.SECTIONS = void 0;
var SECTIONS = exports.SECTIONS = ['companies', 'workplaces', 'cost_centers', 'expense_types'];
var STRUCTURE_MODES = exports.STRUCTURE_MODES = ['DYNAMIC', 'STATIC'];
var STRUCTURE_LEVELS = exports.STRUCTURE_LEVELS = ['EXPENSE_TYPE', 'COST_CENTER'];
var STRUCTURE_NON_DEDUCTIBLE_MODES = exports.STRUCTURE_NON_DEDUCTIBLE_MODES = ['SINGLE', 'MULTIPLE'];